(function () {
  'use strict';

  /* @ngdoc object
   * @name viber
   * @description
   *
   */
  angular
    .module('viber', [
      'ui.router'
    ]);
}());
